import  Sidebar from "./Sidebar";
import './App.css';

function App() {
  return (
    <div className="App">
      <Sidebar />
    </div>
  );
}

export default App;
